import { render, staticRenderFns } from "./editLogSon.vue?vue&type=template&id=956b7520&scoped=true&"
import script from "./editLogSon.vue?vue&type=script&lang=js&"
export * from "./editLogSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956b7520",
  null
  
)

export default component.exports